import React from 'react';
import type { ClueId, WorldState } from '../../types/demo';
import { clues } from '../../data/savanna';
interface SavannaSceneProps {
  world: WorldState;
  label: string;
  highlight?: ClueId | null;
  showLabels?: boolean;
  soundLines?: boolean;
  cliffhanger?: boolean;
}
const IMAGES = {
  base: 'https://cdn.magicpatterns.com/patterns/generated-images/ae77e8df-b6f6-4421-aa8a-1e9e817e3cc1.jpg',
  ally: 'https://cdn.magicpatterns.com/patterns/generated-images/a7ef8110-2e6e-420e-b323-bc3ca7471e5b.jpg',
  sentinel: 'https://cdn.magicpatterns.com/patterns/generated-images/0cd3ff88-ce69-48b0-844d-05bef5f89a6a.jpg',
  cliff: 'https://cdn.magicpatterns.com/patterns/generated-images/3800ddab-8b51-4155-89ab-b3d35d0813cd.jpg'
};
function chip(x: number, y: number, text: string, width: number) {
  return <g transform={`translate(${x} ${y})`} data-id="element-14" data-mp="35iu1m7obb44v">
      <rect width={width} height="26" rx="13" fill="rgba(6,38,44,0.8)" stroke="rgba(255,255,255,0.65)" strokeWidth="1" data-id="element-15" data-mp="35lpxzrkihkr7" />
      <text x={width / 2} y="17.5" textAnchor="middle" fill="#FFFFFF" fontSize="13" fontWeight="700" data-id="element-16" data-mp="1tquuol08jttq">
        {text}
      </text>
    </g>;
}
function glowLine(d: string, color: string, dash: string) {
  return <g fill="none" strokeLinecap="round" data-id="element-17" data-mp="22rsx4yv0zta7">
      <path d={d} stroke={color} strokeWidth="9" opacity="0.25" data-id="element-18" data-mp="22pzsfp3z3j4u" />
      <path d={d} stroke={color} strokeWidth="3" strokeDasharray={dash} data-id="element-19" data-mp="27issw0ses5b4" />
    </g>;
}
export function SavannaScene({
  world,
  label,
  highlight = null,
  soundLines = false,
  cliffhanger = false
}: SavannaSceneProps) {
  const src = cliffhanger ? IMAGES.cliff : world.sentinelNearby ? IMAGES.sentinel : world.allyJoined ? IMAGES.ally : IMAGES.base;
  const highlightClue = highlight ? clues.find(c => c.id === highlight) : null;
  return <div role="img" aria-label={label} className="relative aspect-[16/9] w-full overflow-hidden bg-[#d9c79c]" data-id="element-20" data-mp="s1shh780or3p">
      <img src={src} alt="" width={1376} height={768} decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-21" data-mp="w2kqbzcz8tzg" />
      <svg viewBox="0 0 800 450" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-22" data-mp="1uf6s5oweqndi">
        {!cliffhanger && world.sidePathVisible && <g data-id="element-23" data-mp="28g9hqbmm2ft6">
            {glowLine('M382 362 C340 386 292 404 244 424 C214 436 184 444 150 452', '#E9FFF4', '10 8')}
            {chip(232, 384, 'Side-water path', 132)}
          </g>}
        {cliffhanger && world.sidePathVisible && chip(16, 410, 'Side-water path: still open', 200)}

        {!cliffhanger && world.pathSign && chip(64, 262, 'Path this way →', 128)}

        {!cliffhanger && world.signalLine && glowLine('M346 238 Q 272 228 198 298', '#F7CF62', '2 8')}

        {!cliffhanger && world.pantherFocusClear && <g data-id="element-24" data-mp="313dfbvjdjrux">
            {glowLine('M592 344 L682 278', '#F7CF62', '7 6')}
            {chip(604, 402, 'watching grass', 120)}
          </g>}

        {soundLines && !cliffhanger && <g data-id="element-25" data-mp="2w2g11u1hjhyp">
            {glowLine('M702 252 C694 186 656 146 620 128', '#9BE7F0', '8 6')}
            {chip(566, 100, 'grass sound', 104)}
            {glowLine('M520 196 C500 172 470 160 440 154', '#F7CF62', '1 0')}
            {chip(334, 140, 'group sound', 108)}
          </g>}

        {highlightClue && <g fill="none" data-id="element-26" data-mp="3aqgayejou156">
            <circle cx={highlightClue.position.x / 100 * 800} cy={highlightClue.position.y / 100 * 450} r="40" stroke="#FFFFFF" strokeWidth="8" opacity="0.3" data-id="element-27" data-mp="3apy2mjjr3wgw" />
            <circle cx={highlightClue.position.x / 100 * 800} cy={highlightClue.position.y / 100 * 450} r="40" stroke="#FFFFFF" strokeWidth="2.5" strokeDasharray="6 5" data-id="element-28" data-mp="2n1ope60lsh1d" />
          </g>}
      </svg>
    </div>;
}